import { LinkTypeExtension } from './ContextLinkTypesProvider';
import { GenericLinkEditorForm } from './GenericLinkEditorForm';

export const GenericLinkType: LinkTypeExtension = {
  id: 'generic-link',
  name: 'Link',
  Editor: GenericLinkEditorForm,
  matcher: () => true,
};
